// @flow
import {connect} from 'react-redux';
import type {State as ReduxState} from '../../reducers/index';
import type {SearchQueryResults} from '../../queries/searchQuery';
import type {SERPHitShape, ListingShape} from '../Hit/Hit';
import type {Element as ReactElement} from 'react';

type StateProps = {
    openExpandedGroupIndexes: number[]
};

type Props = StateProps & {
    render: (any) => ReactElement<*>,
    results: ?SearchQueryResults
};

/**
 *
 * augments hits data with any
 * possibly open expanded search groups hits data
 */
// TODO: change this to not use a render prop. It should just be a MapContainer to do this
// Code is tightly coupled and flow types not easy to set using current pattern
// https://jira.homeawaycorp.com/browse/SERP-2858
export function MapHitsDataProvider({
    openExpandedGroupIndexes,
    results,
    render,
    ...rest
}: Props) {
    const {expandedSearchGroups, hits: hitCollectionHits} =
        (results && results.hitCollection) || {};

    const openExpandedSearchGroupsData: {
        hits: SERPHitShape[],
        listings: ListingShape[]
    } = (expandedSearchGroups &&
        expandedSearchGroups.reduce(
            (previousValue, expandedSearchGroup, currentIndex) => {
                if (
                    openExpandedGroupIndexes.includes(currentIndex) &&
                    expandedSearchGroup.hits &&
                    expandedSearchGroup.listings
                ) {
                    return {
                        hits: [
                            ...previousValue.hits,
                            ...expandedSearchGroup.hits
                        ],
                        listings: [
                            ...previousValue.listings,
                            ...expandedSearchGroup.listings
                        ]
                    };
                }
                return previousValue;
            },
            {hits: [], listings: []}
        )) || {hits: [], listings: []};

    const hits = [
        ...(hitCollectionHits || []),
        ...openExpandedSearchGroupsData.hits
    ];
    const listings = [
        ...((results && results.listings) || []),
        ...openExpandedSearchGroupsData.listings
    ];
    return render({hits, listings, ...rest});
}

const mapStateToProps = ({
    expandedSearchGroups: {openGroupIndexes: openExpandedGroupIndexes}
}: ReduxState): StateProps => ({
    openExpandedGroupIndexes
});

export default connect(mapStateToProps)(MapHitsDataProvider);
